import {Injectable} from '@angular/core';
import {Mapper} from '../../../../../core/abstracts/mapper.abstract';
import {VehicleAssignKeyRequest} from '../../../key-number/model/vehicle-assign-key-request.model';

@Injectable({providedIn: 'root'})
export class VehicleAssignKeyRequestMapper extends Mapper<number, VehicleAssignKeyRequest> {
  override map(source: number): VehicleAssignKeyRequest {
    return new VehicleAssignKeyRequest(source);
  }
}
